export const colours = {
    WHITE: '#ffffff',
    LIGHT_BLUE: '#CBE6FF',
    BLUE: '#375E92',
    SCALE: [
        { min: 0, max: 0, color: '#ffffff', label: '0' },
        { min: 1, max: 1, color: '#CBE6FF', label: '1' },
        { min: 2, max: 5, color: '#96C2FF', label: '2-5' },
        { min: 6, max: 10, color: '#375E92', label: '6-10' },
        { min: 11, max: Infinity, color: '#1A365D', label: '11+' }
    ],
    SCALE_100K: [
        { min: 0, max: 0, color: '#ffffff', label: '0' },
        { min: 0.1, max: 4.9, color: '#CBE6FF', label: '1-5' },
        { min: 5, max: 9.9, color: '#96C2FF', label: '5-10' },
        { min: 10, max: 19.9, color: '#375E92', label: '10-20' },
        { min: 20, max: Infinity, color: '#1A365D', label: '20+' }
    ]
}